import { Mail, MessageCircle, MapPin } from "lucide-react";
import { BRAND } from "@/lib/constants";
import { SectionHeader } from "@/components/Services";

export const Contact = () => {
  return (
    <section id="contact" data-testid="contact-section" className="py-24 relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeader eyebrow="Contact" title="Let's build your growth engine." desc="Reach us on WhatsApp for the fastest response, or drop us an email." center />
        <div className="grid md:grid-cols-3 gap-5 max-w-4xl mx-auto">
          <a
            href={BRAND.whatsappLink}
            target="_blank"
            rel="noreferrer"
            data-testid="contact-whatsapp"
            className="glass glass-hover rounded-2xl p-6 flex flex-col items-center text-center transition-all"
          >
            <div className="w-12 h-12 rounded-full grid place-items-center bg-emerald-500/15 border border-emerald-500/40 text-emerald-400 mb-4">
              <MessageCircle size={20} />
            </div>
            <div className="text-[11px] uppercase tracking-[0.22em] text-[#D4AF37] mb-1">WhatsApp</div>
            <div className="text-white font-semibold">{BRAND.phone}</div>
            <div className="text-xs text-white/50 mt-1">Fastest response · IST 9am – 9pm</div>
          </a>

          <a
            href={`mailto:${BRAND.email}`}
            data-testid="contact-email"
            className="glass glass-hover rounded-2xl p-6 flex flex-col items-center text-center transition-all"
          >
            <div className="w-12 h-12 rounded-full grid place-items-center bg-[#D4AF37]/15 border border-[#D4AF37]/40 text-[#D4AF37] mb-4">
              <Mail size={20} />
            </div>
            <div className="text-[11px] uppercase tracking-[0.22em] text-[#D4AF37] mb-1">Email</div>
            <div className="text-white font-semibold break-all">{BRAND.email}</div>
            <div className="text-xs text-white/50 mt-1">Reply within 24 hours</div>
          </a>

          <div className="glass rounded-2xl p-6 flex flex-col items-center text-center">
            <div className="w-12 h-12 rounded-full grid place-items-center bg-white/5 border border-white/10 text-white mb-4">
              <MapPin size={20} />
            </div>
            <div className="text-[11px] uppercase tracking-[0.22em] text-[#D4AF37] mb-1">Country</div>
            <div className="text-white font-semibold">India</div>
            <div className="text-xs text-white/50 mt-1">Serving businesses across all states</div>
          </div>
        </div>
      </div>
    </section>
  );
};
